import { Action } from 'redux'
import { User } from '../../types/user'
import { LeasingContext } from '../../types/leasingContext'

export const SET_ROOT_USER = 'SET_ROOT_USER'
export const SET_LEASE_ID = 'SET_LEASE_ID'
export const SET_LEASING_CONTEXT = 'SET_LEASING_CONTEXT'

interface SetRootUserAction extends Action {
    type: typeof SET_ROOT_USER
    user?: User
}

interface SetLeaseIdAction extends Action {
    type: typeof SET_LEASE_ID
    leaseId?: number
}

interface SetLeasingContextAction extends Action {
    type: typeof SET_LEASING_CONTEXT
    leasingContext?: LeasingContext | null
}

export type UserActionTypes =
    | SetRootUserAction
    | SetLeaseIdAction
    | SetLeasingContextAction
